
class TNTControlBase {
	$onInit(){
		if(this.$state.current.name === `${this.id}`){
			this.$state.go(`${this.id}.all`,{page:1})
		}		
	}
	
	goToAll(){
		this.$state.go(this.id+'.all', ({
			page: 1
		}))
	}	
}

export default TNTControlBase;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/util/TNTControlBase.js